import Vue from 'vue';
import {
  SET_COLLEAGUES_LIST,
  SET_COLLEAGUES_STATUS,
  RESET_COLLEAGUES_STATE,
  SET_COLLEAGUES_CALL_RINGING,
  SET_COLLEAGUES_CALL_IN_PROGRESS,
  SET_COLLEAGUES_CALL_HANGUP,
  SHOW_COLLEAGUES_CALL_RINGING_CARD,
  SHOW_COLLEAGUES_CALL_INPROGRESS_CARD,
  SET_COLLEAGUES_CALL_STATUS,
  RESET_COLLEAGUES_CALL_CARDS,
} from '../../mutation-types';

const mutations = {
  [SET_COLLEAGUES_LIST](state, colleaguesList) {
    state.colleaguesList.data.splice(
      0,
      state.colleaguesList.data.length,
      ...colleaguesList.data,
    );
    delete colleaguesList.data;
    state.colleaguesList.pagination = colleaguesList;
  },
  [SET_COLLEAGUES_STATUS](state, colleaguesStatus) {
    state.colleaguesStatus = colleaguesStatus.data.extenList;
  },
  [RESET_COLLEAGUES_STATE](state) {
    state.colleaguesList.data = [];
    state.colleaguesList.pagination = [];
    state.colleaguesStatus = [];
  },
  [SHOW_COLLEAGUES_CALL_RINGING_CARD](state, value) {
    state.showColleaguesCallRingingCard = value;
  },
  [SHOW_COLLEAGUES_CALL_INPROGRESS_CARD](state, value) {
    state.showColleaguesCallInProgressCard = value;
  },
  [SET_COLLEAGUES_CALL_RINGING](state, params) {
    state.activeInternalCallStatus = params.status;
    state.activeInternalCalllColleagueInfo = params.colleagueInfo;
  },
  [SET_COLLEAGUES_CALL_IN_PROGRESS](state, params) {
    state.activeInternalCallStatus = params;
  },
  [SET_COLLEAGUES_CALL_STATUS](state, params) {
    state.activeInternalCallStatus = params;
  },
  [SET_COLLEAGUES_CALL_HANGUP](state) {
    state.activeInternalCallStatus = null;
    state.showColleaguesCallRingingCard = false;
    state.showColleaguesCallInProgressCard = false;
  },
  [RESET_COLLEAGUES_CALL_CARDS](state) {
    state.activeInternalCallStatus = null;
    state.activeInternalCalllColleagueInfo = null;
    state.showColleaguesCallRingingCard = false;
    state.showColleaguesCallInProgressCard = false;
  },
};

export default mutations;
